import { keyBy } from '../../helpers/common'
import {
  FORMAT,
  compareTwoDateTime,
  formatDateTime,
  getCurrentDateTime,
} from '../../helpers/datetime'
import { SCREEN_TYPE } from '../constants'
import { NOTIFICATIONS_DEFAULT } from './slice'

export const keyById = (payload, key) => {
  if (!payload.length) return {}

  const result = {}
  payload.forEach((item) => {
    result[item[key]] = {
      ...item,
      event: {
        title: item.notificationTypeName,
        subtitle: item.notificationTypeDescription,
      },
    }
  })

  return result
}

export const handleNotificationsData = (
  { data = [] },
  { screenType, isScroll },
  prevData,
) => {
  if (!data || !data.length) return NOTIFICATIONS_DEFAULT

  const currentDate = formatDateTime(getCurrentDateTime(), FORMAT.DATE)
  const todayData = data.filter(
    (item) => formatDateTime(item.createDate, FORMAT.DATE) === currentDate,
  )

  const olderData = data.filter(
    (item) => formatDateTime(item.createDate, FORMAT.DATE) !== currentDate,
  )

  if (screenType === SCREEN_TYPE.POPUP && isScroll) {
    return handlePopupData(todayData, olderData, prevData)
  }

  return {
    todayData: addField(todayData),
    olderData: addField(olderData),
  }
}

const addField = (data) => {
  const dataWithNewField = data.map((item) => {
    return {
      ...item,
      title: item.message,
      createdAt: item.createDate,
      isShow: true,
    }
  })

  return keyBy(dataWithNewField, 'id')
}

const handlePopupData = (todayData, olderData, prevData) => {
  const cloneData = JSON.parse(JSON.stringify(prevData))
  return {
    todayData: {
      ...addField(todayData),
      ...cloneData.todayData,
    },
    olderData: {
      ...addField(olderData),
      ...cloneData.olderData,
    },
  }
}

export const handleIds = (data) => {
  const todayValues = Object.values(data.todayData)
  const olderValues = Object.values(data.olderData)

  return {
    todayIds: sortIds(todayValues),
    olderIds: sortIds(olderValues),
  }
}

export const sortIds = (ids) => {
  return ids
    .sort((a, b) => compareTwoDateTime(b.createDate, a.createDate))
    .map((item) => item.id)
}
